import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Box, Divider, Flex, Image, Stack, Text, rem } from '@mantine/core';
import { ProfileCharacter } from './ProfileCharacter';
export const ProfileEmailContentSuccess: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Stack h="calc(100vh - 200px)" gap={10} p={10} bg={{
    sm: 'var(--bg-200)',
    lg: 'transparent'
  }}>
      <Flex direction="column" align={{
      sm: 'center',
      lg: 'start'
    }} mt={40}>
        <Text fz={rem(24)} className={gunterzBold.className}>
          {i18n._('Welcome to')}
        </Text>
        <Image src="/assets/kyc/prime.svg" alt="logo" w={{
        sm: 160,
        lg: 189
      }} h={{
        sm: 62,
        lg: 67
      }} />
      </Flex>
      <Divider size="sm" c="var(--icon-primary)" />
      <Box>
        <Text fz={{
        sm: rem(18),
        lg: rem(21)
      }} c="var(--text-dark)" className={gunterzBold.className} ta={{
        base: 'center',
        lg: 'left'
      }}>
          {i18n._('Rour primeorb can be minted on the eth network, allowing you to sell it on our upcoming marketplace')}
        </Text>
      </Box>
      <Divider size="sm" c="var(--icon-primary)" />

      <Text fz={rem(12)} fw={700} tt="uppercase" c="var(--text-dark)" ta={{
      base: 'center',
      lg: 'left'
    }}>
        {i18n._('(YOU’LL LOSE ALL OF IT’S BENEFITS IF SOLD, SO BETTER KEEP IT!)')}
      </Text>

      <ProfileCharacter visible="sm" hidden="lg" />
    </Stack>;
};